import React, {FC, useEffect, useState} from "react";
import {Select} from "../../../../lib/src/components/form/Select";
import {
  ProjectVisitStatus,
  projectVisitStatusEnum,
  ProjectVisitType,
  projectVisitTypeEnum
} from "../../../../lib/src/api/dto/ProjectVisit";
import config from "../../config";
import {useNavigate} from "react-router";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import {ValidationError} from "../../api/api";
import {useFetchedResource} from "../../api/APIContext";
import {getToken} from "@ventumsoftware/react-toolkit";
import {ProjectVisit} from "@traas/lib/src/api/dto/ProjectVisit";
import {useApiService} from "@traas/lib/src/api/hooks/useApiService";
import {Project} from "@traas/lib/src/api/dto/Project";
import {Task} from "@traas/lib/src/api/dto/Task";
import {Input} from "@traas/lib/src/components/form/Input";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";


export const EditProjectVisitModal: FC<{ visit: ProjectVisit, onFinished?: () => void }> = (props) => {
  const navigate = useNavigate();
  const { projectService, projectVisitService, taskService } = useApiService(config, getToken, navigate)

  const [name, setName] = useState<string>(props.visit.name ?? '')
  const [date, setDate] = useState(new Date(props.visit.targetDate) ?? new Date())
  const [type, setType] = useState<string>(props.visit.type ?? '-')
  const [offsetBeforeExecutionDate, setOffsetBeforeExecutionDate] = useState<number|null>(props.visit.offsetBeforeExecutionDate ?? null)
  const [status, setStatus] = useState<string>(props.visit.status ?? '-')
  const [errors, setErrors] = React.useState<string[]>([])
  const {resource: projects, reload: reloadProjects} = useFetchedResource<Project[]>(() => projectService.browse())
  const {resource: tasks, reload: reloadTasks} = useFetchedResource<Task[], string>((selectedProject) => taskService.browseByProjectId(selectedProject))

  useEffect(() => {
    reloadProjects(undefined)
  }, [props.visit]);

  const confirm = async () => {
    await projectVisitService.edit(
      props.visit.id,
      name,
      type,
      status,
      date,
      offsetBeforeExecutionDate
    ).catch(e => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat())
        }
        throw e
      })
    props.onFinished?.()
  }

  return <div>
  <div className={'grid grid-cols-2 gap-4'}>
    <div className={'col-span-2'}>
      <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    </div>

    <div className={'col-span-1'}>
      <Select label={'Type'}
              options={{
                '-': 'Selecteer een type',
                ...projectVisitTypeEnum
              }}
              value={type}
              onChange={(v) => setType(v as ProjectVisitType|'-')}
      />
    </div>

    <div className={'col-span-1'}>
      <Select label={'Status'}
              options={{
                '-': 'Selecteer een status',
                ...projectVisitStatusEnum
              }}
              value={status}
              onChange={(v) => setStatus(v as ProjectVisitStatus|'-')}
      />
    </div>

    {type === projectVisitTypeEnum["Voor uitvoering"] && <div>
      <Input type={'number'} label={'Aantal dagen voor uitvoering'} value={offsetBeforeExecutionDate!} onChange={setOffsetBeforeExecutionDate} min={0} />
    </div>}

    <div className={"col-span-2 grid grid-cols-2 gap-4"}>
      <Input type={"date"} label={"Datum"} value={date} onChange={(newDate) => {
        newDate.setHours(date.getHours())
        newDate.setMinutes(date.getMinutes())
        setDate(newDate)
      }}/>
    </div>
  </div>

    <ModalFooter text={'Opslaan'} icon={faSave} onSubmit={confirm} />
  </div>
}